import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import LongMenuIcon from "../../src/assets/images/ic_long_menu.svg"
import './cardStyle.css'
//import verticalDots from '../../../assets/images/verticalDots.jpeg';

// const options = ["See on map", "Call"];

// const ITEM_HEIGHT = 30;

export default function LongMenu({options,ITEM_HEIGHT,phoneNo,openMap,latitude,longitude,countryCode}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls="long-menu"
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <img
                            src={LongMenuIcon}
                            alt=""
                            style={{ marginTop: "11px"}}
                          />
                {/* <img src={verticalDots} alt={"logo"} style={{ height: "5px", width: "5px" }} /> */}
            </IconButton>
            <Menu
                id="long-menu"
                MenuListProps={{
                    "aria-labelledby": "long-button"
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.6,
                        width: "15ch"
                    }
                }}
            >
                {options.map((option,index) => (
                    <MenuItem
                        key={option}
                        selected={option === "Pyxis"}
                        onClick={handleClose}
                    >
                        {option === 'Call' ? (<a className={options.length - 1 === index ? "option" : "optionWithDivider"} href={`tel:${countryCode}-${phoneNo}`}>{option} </a>) : <div className={options.length - 1 === index ? "option" : "optionWithDivider"} onClick={()=>openMap(latitude,longitude)}>{option}</div>}
                        
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
